export default "__VITE_ASSET__9bGHfsLI__"